module.exports = __webpack_public_path__ + "static/media/kultur.05f9d9ee.png";